import { inject, Injectable } from '@angular/core';
import { HisBaseGlobalsService } from '../../service/base/his-base-globals.service';
@Injectable( { providedIn: 'root' } )
export class HisScriptLoaderService {
    private isTestEnvironment = this.detectTestEnvironment();
    private hisBaseGlobalsService = inject( HisBaseGlobalsService );

    // lade script
    private loadScript( src: string, async:boolean = false, defer:boolean = false ): Promise<void> {
        if ( this.isTestEnvironment ) {
            // Setup Test Doubles statt echte Skripte zu laden
            return Promise.resolve();
        }
        return new Promise( ( resolve, reject ) => {
            // Script schon vorhanden?
            if ( document.querySelector( `script[data-hisng-src="${src}"]` ) ) {
                return resolve();
            }
            const versionHash = this.hisBaseGlobalsService.versionHash || 'no-version';
            const script = document.createElement( 'script' );
            script.src = src.includes( '?' ) ? `${src}&v=${versionHash}` : `${src}?v=${versionHash}`;

            // sequentielle Ausführung der Scripte ist für abhängige Skripte z.B. Codemirror Core-/Language Bundle wichtig
            // "loose" Scripte profitieren von async/defer, da sie nicht aufeinander angewiesen sind und die Ladezeit optimiert werden kann
            script.async = async;
            script.defer = defer;
            script.dataset.hisngSrc = src;

            script.onload = () => resolve();
            script.onerror = () => reject( new Error( 'Fehler beim Laden: ' + script.src ) );

            document.body.appendChild( script );
        } );
    }

    loadJSFScript( name: string, library: string, async = false, defer = false ): Promise<void> {
        const contextPath = this.resolveContextPath();
        const url = `${contextPath}/jakarta.faces.resource/${name}.faces?ln=${library}`;
        return this.loadScript( url, async, defer );
    }

    loadAssetsScript( src: string, async = false, defer = false ): Promise<void> {
        const contextPath = this.resolveContextPath();
        const url = `${contextPath}/a/cs.sys.hisng/assets/${src}`;
        return this.loadScript( url, async, defer );
    }

    // lade mehrere Scripte in Serie (wichtig bei Anhängigkeiten)
    async loadAssetsScriptInOrder( srcs: string[] ): Promise<void> {
        for ( const s of srcs ) {
            await this.loadAssetsScript( s, false, false );
        }
    }

    async loadJSFScriptsInOrder( scripts: { name: string, library: string }[] ): Promise<void> {
        for ( const script of scripts ) {
            await this.loadJSFScript( script.name, script.library, false, false );
        }
    }

    waitFor<T>( condition: () => T, timeout = 3000, interval = 100 ): Promise<T> {
        if ( this.isTestEnvironment ) {
            return Promise.resolve( condition() );
        }

        return new Promise( ( resolve, reject ) => {
            const start = Date.now();
            const check = () => {
                const result = condition();
                if ( result ) {
                    resolve( result );
                } else if ( Date.now() - start >= timeout ) {
                    reject( 'Timeout while waiting for condition' );
                } else {
                    setTimeout( check, interval );
                }
            };
            check();
        } );
    }


    // Hilfsfunktionen: bestimme contextPath
    private getBaseElHref(): string | null {
        const baseEl = document.querySelector( 'base' );
        return baseEl ? baseEl.getAttribute( 'href' ) : '';
    }

    private resolveContextPath(): string {
        const pathname = window.location.pathname;
        const match = pathname.match( /^\/([^/]+)\// );
        return match ? `/${match[1]}` : '';
    }

    private detectTestEnvironment(): boolean {
        return typeof ( globalThis as any ).jasmine !== 'undefined' ||
            typeof ( globalThis as any ).jest !== 'undefined' ||
            typeof ( globalThis as any ).__karma__ !== 'undefined';
    }

}
